var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCongrats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48,
    stroke: "#46C35F",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.5366 48.1685C79.1787 47.1528 80.1893 45.189 79.9366 43.0221C79.6208 40.3134 77.284 38.4173 74.7577 38.4173H58.9682C59.0945 38.0788 59.284 37.6047 59.4103 37.1984C60.3577 34.6252 62.1261 29.8851 62.1261 25.0095C62.1261 19.5244 58.5261 16.2063 56.0629 16.0032C54.5471 15.9355 53.4103 16.9512 53.1577 18.7796C52.7156 22.2331 50.5682 27.3118 49.684 29.2756C49.4314 29.8851 49.1156 30.4268 48.6735 30.9008C47.2208 32.6614 43.5577 36.9953 40.084 39.5685C40.084 39.704 40.1471 39.9071 40.1471 40.0425V72.4787C40.1471 72.7496 40.084 73.0205 40.084 73.2913C46.0208 75.1197 51.3892 76 57.2629 76H70.7156C73.0524 76 75.2629 74.3071 75.705 71.8693C76.084 69.8378 75.3892 68.0095 74.1261 66.7906C76.2735 66.2488 77.9156 64.1496 77.9156 61.7118C77.9156 60.1543 77.284 58.7323 76.2103 57.7843C78.3577 57.2425 79.9998 55.1433 79.9998 52.7055C79.9998 50.8095 79.0524 49.1166 77.5366 48.1685Z",
    fill: "#46C35F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2 37.1985H22.6526C21.2 37.1985 20 38.4851 20 40.0425V72.4787C20 74.0362 21.2 75.3228 22.6526 75.3228H33.2C34.6526 75.3228 35.8526 74.0362 35.8526 72.4787V40.1103C35.8526 38.4851 34.7158 37.1985 33.2 37.1985ZM27.9579 70.3795C26.4421 70.3795 25.1789 69.0252 25.1789 67.4C25.1789 65.7748 26.4421 64.4205 27.9579 64.4205C29.4737 64.4205 30.7368 65.7748 30.7368 67.4C30.7368 69.0252 29.4737 70.3795 27.9579 70.3795Z",
    fill: "#46C35F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongrats);
export default __webpack_public_path__ + "static/media/congrats.53dc7603088eb4fc47176ecf43082d5f.svg";
export { ForwardRef as ReactComponent };